// EG-27: modelos padrão de selo. `value` casa com `certificate.seal_model` e com
// a chave usada nos endpoints /certificate/seal-models/:model.
export const SEAL_MODELS = [
  { value: 'ESG', label: 'Selo ESG' },
  { value: 'ODS', label: 'Selo ODS' },
];

export const SEAL_MODEL_LABELS = SEAL_MODELS.reduce((acc, model) => {
  acc[model.value] = model.label;
  return acc;
}, {});
